/// <reference types="vite/client" />
import { queryOptions, useQuery, UseQueryResult } from '@tanstack/react-query';
import useParties from '../useParties/useParties';
import { spiceroad } from '..';
import { TermLoan } from 'merchant-api/types';

export interface UseLoanProps {
  activeTL: boolean;
  loan: TermLoan;
  loanError: any;
  loanLoading: boolean;
  query: UseQueryResult<any>;
}

const getLoan = (loanId: string) =>
  spiceroad.get(`/v1/loans/${loanId}`).then((res) => res.data);

export const getLoanOpts = (loanId: string) =>
  queryOptions({
    queryKey: ['loan', loanId],
    queryFn: () => getLoan(loanId),
  });

export function useLoan(): UseLoanProps {
  const { hasTL } = useParties();
  const query = useQuery({
    ...getLoanOpts(hasTL!),
    enabled: !!hasTL,
  });
  const { data, error, isLoading } = query;

  return {
    activeTL: data?.status === 'ACTIVE',
    loan: data,
    loanError: error,
    loanLoading: isLoading,
    query,
  };
}

export default useLoan;
